import SubHeaders from '@/components/Headers/SubHeaders'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getResellerById } from '../../services'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import useTabs from '@/hooks/useTabs'
import { Tabs } from 'vnetwork-ui'
import { tabs } from './tabs'

const Detail = () => {
    const { t } = useTranslation('reseller')
    const { id } = useParams()

    const {
        data: reseller,
        renderState,
        refetch,
    } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.RESELLERS, 'detail', id],
        queryFn: () => getResellerById(Number(id)),
    })

    const { TabProps, TabComponent } = useTabs({
        tabs: tabs({
            t,
            reseller: reseller?.result,
            resellerId: Number(id),
            refetch,
        }),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.resellersList,
                        title: t('reseller_manager'),
                    },
                    {
                        path: generatePathDatacentral(paths.resellerDetail, {
                            id: id || '',
                        }),
                        title: reseller?.result?.reseller_name || '',
                    },
                ]}
            />

            <div className="bg-white rounded-md mt-2">
                <Tabs {...TabProps} tabContainerClassName="pt-0" />
            </div>

            {TabComponent}
        </div>
    )
}

export default Detail
